export const brandStatusHandler = {
    pathPattern: '/brands/:brandId/brand-status/overview',
    toWeb: ({ brandId }) => ({
        path: `/brands/${brandId}/brand-status/overview`,
    }),
    toNative: ({ brandId }, locationId) => `/${brandId}/${locationId}/brand-status/overview`,
    meta: {
        title: 'Brand status / onboarding',
        description: 'Opens the brand onboarding/status overview.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=brand-status.js.map